import Box from "@mui/material/Box";
import InputCheckbox from "common/components/Elements/Form/InputCheckbox/InputCheckbox";
import InputCheckboxGroup from "common/components/Elements/Form/InputCheckboxGroup/InputCheckboxGroup";
import InputModalLabel from "common/components/Elements/Form/InputModalLabel/InputModalLabel";
import ModalActions from "common/components/Elements/Modal/ModalActions/ModalActions";
import SimpleModal, { ScrollableModalContent } from "common/components/Elements/Modal/SimpleModal/SimpleModal";
import type { ApplicationState } from "core/redux/reducers/rootReducer";
import type { AppDispatch } from "core/redux/store/configureStore.types";
import type { ValueLabelOption } from "core/utilities/core.types";
import I18n from "i18n/en-US";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { LABEL_COMPONENT } from "sequenceAnalyser/global/settings.ts";
import {
  updateLabelCompositionSetting,
  updateShowHoveredResidueTooltipSetting,
} from "sequenceAnalyser/redux/actions/sequenceAnalyserActions";

interface ComponentProps {
  open: boolean;
  onOpen: (open: boolean) => void;
}

function SettingsModal({ open, onOpen }: ComponentProps) {
  const settings = useSelector((state: ApplicationState) => state.sequenceAnalyser.settings);
  const dispatch = useDispatch<AppDispatch>();

  const labelCompositionOptions: ValueLabelOption[] = [
    { value: LABEL_COMPONENT.GENOME, label: "Genome or Database" },
    { value: LABEL_COMPONENT.SEQUENCE_NAME, label: "Sequence Name" },
    { value: LABEL_COMPONENT.LOCATION, label: "Location" },
    { value: LABEL_COMPONENT.COMPLEMENT, label: "Complement Info" },
  ];

  const getLabelCompositionValues = () => settings.labelComposition;

  return (
    <SimpleModal
      title={I18n.SequenceAnalyser.SettingsModal.title}
      open={open}
      onClose={() => {
        onOpen(false);
      }}
      content={
        <Box mt={1}>
          <ScrollableModalContent>
            <>
              <Box mt={2} />

              <InputCheckboxGroup
                label={I18n.SequenceAnalyser.SettingsModal.labelCompositionLabel}
                values={getLabelCompositionValues()}
                options={labelCompositionOptions}
                onChange={(value) => {
                  let newLabelComposition = [...getLabelCompositionValues()];

                  if (newLabelComposition.includes(value)) {
                    newLabelComposition = newLabelComposition.filter((v) => v !== value);
                  } else {
                    newLabelComposition.push(value);
                  }

                  dispatch(updateLabelCompositionSetting(newLabelComposition));
                }}
                modalLabel
              />

              <Box mt={2} />

              <InputModalLabel>Other</InputModalLabel>

              <InputCheckbox
                checked={settings.showHoveredResidueTooltip}
                label={I18n.SequenceAnalyser.SettingsModal.tooltipToggle}
                onChange={() => dispatch(updateShowHoveredResidueTooltipSetting(!settings.showHoveredResidueTooltip))}
              />
            </>
          </ScrollableModalContent>

          <ModalActions noApply />
        </Box>
      }
    />
  );
}

export default SettingsModal;
